/* ══════════════════════════════════════════════════════════════════════════════
   SIGNAL PROVA — il camerino, dentro la scheda prodotto.

   Nessuna libreria, nessuna dipendenza, niente che tocchi il resto del tema: gira sui
   siti dei clienti, dove qualunque cosa aggiunta è una cosa che può rompersi e che non
   possiamo aggiustare da qui.

   TRE DECISIONI CHE VALE LA PENA CONOSCERE PRIMA DI CAMBIARE QUALCOSA:

   1. LA FOTO SI RIMPICCIOLISCE QUI, NEL BROWSER, prima di partire. Una foto di un
      telefono di oggi è 4000 pixel e 5 MB; al motore ne servono 1280. Rimpicciolirla qui
      rende il caricamento istantaneo anche in 4G — ma soprattutto è meno dato che esce dal
      telefono di chi sta comprando. Il posto più sicuro dove tenere una foto è dove già sta.

   2. IL PULSANTE NON ESISTE FINCHÉ IL SERVER NON DICE CHE È ACCESO. Niente pulsante
      stampato e poi nascosto: su una connessione lenta resterebbe lì, cliccabile, a non
      fare niente.

   3. IL CONSENSO È UNA SCHERMATA, NON UNA SPUNTA. Si legge prima di scegliere il file,
      e il pulsante che apre la fotocamera è lo stesso che dice «ho capito». Una spunta
      sotto un pulsante è una cosa che si salta.
   ══════════════════════════════════════════════════════════════════════════════ */

(function () {
  "use strict";

  var posto = document.querySelector("[data-signal-tryon]");
  if (!posto || posto.dataset.montato) return;
  posto.dataset.montato = "1";

  var BASE = "https://" + (posto.dataset.dominio || "signal.editstudio.agency");
  var NEGOZIO = posto.dataset.negozio || "";
  var PRODOTTO = Number(posto.dataset.prodotto || 0);
  var TIPO = posto.dataset.tipo || "";
  var TITOLO = posto.dataset.titolo || "";
  /* `capo.available` in Liquid stampa «true»/«false»: qualunque altra cosa vuol dire che
     il tema non l'ha passato, e in quel caso si prova comunque — sarà il server a dire
     che è esaurito, che è l'unico che lo sa davvero. */
  var ESAURITO = posto.dataset.disponibile === "false";

  if (!NEGOZIO || !PRODOTTO || ESAURITO) return;

  var gettone = null, riferimento = null, ultimaFoto = null, dialogo = null, aperto = false;
  var flusso = null;   // la fotocamera accesa, se lo è
  var carrelloContrassegnato = false;

  function url(rotta) {
    return BASE + "/api/tryon/pubblico/" + rotta + "?shop=" + encodeURIComponent(NEGOZIO);
  }
  function parla(rotta, corpo, metodo) {
    return fetch(url(rotta), {
      method: metodo || "POST",
      headers: { "Content-Type": "application/json", "X-Signal-Gettone": gettone || "" },
      body: metodo === "GET" ? undefined : JSON.stringify(corpo || {}),
    }).then(function (r) { return r.json().catch(function () { return { ok: false, errore: "Risposta non leggibile." }; }); });
  }

  /* ── IL CONTRASSEGNO SUL CARRELLO ────────────────────────────────────────
     È l'unico filo che lega una prova a un ordine. Senza, «la prova fa vendere?» resta
     una domanda senza risposta — e non è una risposta che si recupera dopo: un carrello
     non contrassegnato oggi è un ordine che domani non si saprà da dove veniva.

     Porta il riferimento della sessione, MAI il gettone: quello autentica, e non deve
     finire nei dati di un ordine di un cliente. Si scrive una volta sola per pagina. */
  function contrassegnaCarrello(poi) {
    if (!riferimento || carrelloContrassegnato) { if (poi) poi(); return; }
    carrelloContrassegnato = true;
    try {
      fetch("/cart/update.js", {
        method: "POST", keepalive: true,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { SIGNAL_TRYON: riferimento } }),
      }).then(function () { if (poi) poi(); })
        .catch(function () { carrelloContrassegnato = false; if (poi) poi(); });
    } catch (e) { carrelloContrassegnato = false; if (poi) poi(); }
  }

  /* ── IL PULSANTE PRENDE LA FORMA DEL TEMA ────────────────────────────────
     Non sappiamo come si chiamano le classi dei pulsanti di questo negozio: «button»,
     «btn», «product-form__submit» — ogni tema il suo, e sono migliaia. Quindi non si
     indovina: si GUARDA il pulsante «Aggiungi al carrello», che in una scheda prodotto
     c'è sempre, e gli si copiano le misure che il browser ha già calcolato. Carattere,
     corpo, spaziatura fra le lettere, maiuscole, raggio degli angoli, altezza: è quello
     che fa somigliare un pulsante a QUEL negozio invece che a noi.

     NON si copiano i colori, ed è una scelta. Un secondo pulsante pieno, identico, sotto
     «Aggiungi al carrello» gli competerebbe contro — e il carrello deve vincere sempre.
     Il nostro resta in negativo: bordo e testo del colore del testo della pagina, che è
     il modo in cui i temi fanno i pulsanti secondari.

     Se il tema si può passare una classe sua (`classe:` nello snippet), quella vince su
     tutto: è la via d'uscita per il caso in cui copiare non basti. */
  function vestiComeIlTema(b) {
    var scelta = (posto.dataset.classe || "").trim();
    if (scelta) { b.className = scelta; return; }

    var rif = document.querySelector('form[action*="/cart/add"] button[type="submit"]')
           || document.querySelector('form[action*="/cart/add"] [type="submit"]')
           || document.querySelector('form[action*="/cart/add"] button');
    if (!rif || !window.getComputedStyle) return;
    try {
      var s = window.getComputedStyle(rif);
      var copia = ["fontFamily", "fontSize", "fontWeight", "fontStyle", "letterSpacing",
                   "textTransform", "borderRadius", "borderStyle", "borderWidth",
                   "paddingTop", "paddingBottom", "paddingLeft", "paddingRight", "lineHeight"];
      for (var i = 0; i < copia.length; i++) { if (s[copia[i]]) b.style[copia[i]] = s[copia[i]]; }

      // Un tema che fa i pulsanti senza bordo: il nostro, in negativo, ne ha bisogno per esistere.
      if (!(parseFloat(s.borderWidth) >= 1)) { b.style.borderWidth = "1px"; b.style.borderStyle = "solid"; }

      /* L'ALTEZZA NON SCENDE SOTTO I 44 PIXEL anche se quella del tema è più bassa: si usa
         col pollice, in piedi, spesso male. Un pulsante di 34px è bello e si sbaglia. */
      var h = parseFloat(s.height) || 0;
      b.style.minHeight = Math.max(44, h) + "px";

      /* Se «Aggiungi al carrello» prende tutta la riga, anche il nostro: un bottoncino
         stretto sotto un pulsante a tutta larghezza sembra una cosa aggiunta dopo. */
      var padre = rif.parentElement;
      if (padre && rif.offsetWidth >= padre.clientWidth * 0.9) {
        /* `flex`, NON `block`: block spegne la disposizione a righe e con lei lo spazio fra
           icona e testo — su un negozio vero sono usciti attaccati, «⊡PROVALO SU DI TE». */
        b.style.display = "flex"; b.style.width = "100%";
        b.style.alignItems = "center"; b.style.justifyContent = "center";
      }
      b.classList.add("sp-vestito");
    } catch (e) { /* si tiene il nostro aspetto: meglio diverso che rotto */ }
  }

  /* L'ICONA È UN DISEGNO, non un carattere.
     Prima era «◰», e un carattere lo disegna il font del tema: su un negozio vero è uscito
     un quadratino storto, e su un tema con un font che quel segno non ce l'ha sarebbe uscito
     il rettangolo vuoto. Un disegno in linea viene identico ovunque, prende da sé il colore
     del testo e cresce col corpo. Una gruccia e non una macchina fotografica: qui non si
     fotografa, si indossa. */
  function gruccia() {
    var NS = "http://www.w3.org/2000/svg";
    var s = document.createElementNS(NS, "svg");
    s.setAttribute("viewBox", "0 0 24 24");
    s.setAttribute("fill", "none");
    s.setAttribute("stroke", "currentColor");
    s.setAttribute("stroke-width", "1.6");
    s.setAttribute("stroke-linecap", "round");
    s.setAttribute("stroke-linejoin", "round");
    s.setAttribute("aria-hidden", "true");
    s.setAttribute("class", "sp-invito-i");
    var gancio = document.createElementNS(NS, "path");
    gancio.setAttribute("d", "M12 9.2V7.8a2.1 2.1 0 1 1 2.1-2.1");
    var corpo = document.createElementNS(NS, "path");
    corpo.setAttribute("d", "M12 9.2 3.5 15a1.05 1.05 0 0 0 .6 1.9h15.8a1.05 1.05 0 0 0 .6-1.9L12 9.2Z");
    s.appendChild(gancio); s.appendChild(corpo);
    return s;
  }

  function el(tag, classe, testo) {
    var e = document.createElement(tag);
    if (classe) e.className = classe;
    if (testo != null) e.textContent = testo;
    return e;
  }

  /* ── LA FOTO, RIMPICCIOLITA PRIMA DI PARTIRE ──────────────────────────────
     1280 sul lato lungo: è quello che serve al motore per vedere un corpo e un viso.
     JPEG all'85%: sopra non si distingue, sotto cominciano gli artefatti sulla pelle.
     Se il browser non sa disegnare su una tela — succede, su telefoni vecchi — si manda
     l'originale invece di fallire: meglio un caricamento lento di un camerino rotto. */
  function rimpicciolisci(file) {
    return new Promise(function (risolvi) {
      var lettore = new FileReader();
      lettore.onerror = function () { risolvi(null); };
      lettore.onload = function () { stringi(String(lettore.result || "")).then(risolvi); };
      lettore.readAsDataURL(file);
    });
  }

  /* Lo stesso lavoro su un'immagine che è già un data URL: è quello che esce dallo scatto
     della fotocamera, che non passa da nessun file. */
  function stringi(originale) {
    return new Promise(function (risolvi) {
      {
        var img = new Image();
        // Non si manda al server qualcosa che non siamo riusciti nemmeno ad aprire:
        // il rifiuto arriverebbe uguale, ma dopo il caricamento e con parole nostre peggiori.
        img.onerror = function () { risolvi(null); };
        img.onload = function () {
          try {
            var lato = 1280;
            var s = Math.min(1, lato / Math.max(img.width, img.height));
            if (s >= 1) return risolvi(originale);
            var tela = document.createElement("canvas");
            tela.width = Math.round(img.width * s);
            tela.height = Math.round(img.height * s);
            var c = tela.getContext("2d");
            if (!c) return risolvi(originale);
            c.drawImage(img, 0, 0, tela.width, tela.height);
            risolvi(tela.toDataURL("image/jpeg", 0.85));
          } catch (e) { risolvi(originale); }
        };
        img.src = originale;
      }
    });
  }

  /* ── I PUNTINI CHE ASPETTANO ──────────────────────────────────────────────
     Una prova richiede una ventina di secondi. Venti secondi senza niente che si muove
     sono venti secondi in cui una persona pensa che si sia rotto e ricarica la pagina —
     buttando via la generazione che stava pagando il negozio. */
  function attesa(dove) {
    var box = el("div", "sp-attesa");
    var p = el("div", "sp-punti");
    for (var i = 0; i < 3; i++) { var d = el("span"); d.style.animationDelay = (i * 0.16) + "s"; p.appendChild(d); }
    box.appendChild(p);
    box.appendChild(el("p", "sp-attesa-t", "Ti sto vestendo… una ventina di secondi."));
    dove.appendChild(box);
    return box;
  }

  /* ── IL RIQUADRO ──────────────────────────────────────────────────────── */

  function fermaFotocamera() {
    if (!flusso) return;
    try { flusso.getTracks().forEach(function (tr) { tr.stop(); }); } catch (e) { /* già spenta */ }
    flusso = null;
  }

  function chiudi() {
    fermaFotocamera();
    if (!dialogo) return;
    dialogo.remove(); dialogo = null; aperto = false;
    document.documentElement.style.overflow = "";
    if (bottone) bottone.focus();
  }

  function apri(config) {
    if (aperto) return;
    aperto = true;
    // Il corpo non scorre dietro al riquadro: su telefono è il difetto che si nota subito.
    document.documentElement.style.overflow = "hidden";

    dialogo = el("div", "sp-fondo");
    dialogo.setAttribute("role", "dialog");
    dialogo.setAttribute("aria-modal", "true");
    dialogo.setAttribute("aria-label", "Camerino virtuale");
    dialogo.addEventListener("click", function (e) { if (e.target === dialogo) chiudi(); });

    var scatola = el("div", "sp-scatola");
    var x = el("button", "sp-x", "✕");
    x.type = "button"; x.setAttribute("aria-label", "Chiudi");
    x.addEventListener("click", chiudi);
    scatola.appendChild(x);

    var corpo = el("div", "sp-corpo");
    scatola.appendChild(corpo);
    dialogo.appendChild(scatola);
    document.body.appendChild(dialogo);

    document.addEventListener("keydown", function esc(e) {
      if (e.key === "Escape" && aperto) { chiudi(); document.removeEventListener("keydown", esc); }
    });

    schermataConsenso(corpo, config);
    x.focus();
  }

  /* 1. IL CONSENSO. Si legge prima, e il pulsante che apre la fotocamera è lo stesso
        che dice «ho capito»: una spunta sotto un pulsante è una cosa che si salta. */
  function schermataConsenso(corpo, config) {
    corpo.innerHTML = "";
    var c = config.consenso || {};
    corpo.appendChild(el("h2", "sp-tit", c.titolo || "Una foto e lo vedi addosso"));
    var ul = el("ul", "sp-punti-elenco");
    (c.punti || []).forEach(function (p) { ul.appendChild(el("li", null, p)); });
    corpo.appendChild(ul);

    /* LO SPECCHIO PRIMA DELL'ARCHIVIO.
       «Carica un file» non è un camerino: è un modulo. Chi sta guardando un capo vuole
       vedersi, non cercare una cartella. Quindi la fotocamera è la strada PRINCIPALE e si
       apre qui dentro — ci si inquadra, si scatta, si vede il risultato — e la galleria
       resta per chi ha già la foto giusta, presa da lontano o da qualcun altro.

       Vale anche da computer: `getUserMedia` accende la webcam come sul telefono. Prima la
       fotocamera si proponeva solo su schermo tattile, e da desktop restava solo il file —
       che è esattamente la parte che non andava bene. */
    var puoInquadrare = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);

    var galleria = el("input");
    galleria.type = "file";
    // `image/*` e non l'elenco stretto: gli iPhone consegnano HEIC, e il ridimensionamento
    // lo trasforma comunque in JPEG prima di partire.
    galleria.accept = "image/*";
    galleria.className = "sp-file";
    galleria.addEventListener("change", function () {
      if (galleria.files && galleria.files[0]) {
        rimpicciolisci(galleria.files[0]).then(function (d) {
          if (!d) return errore(corpo, "Questa foto non riesco ad aprirla: scegline un'altra.");
          scegliTaglia(corpo, config, d);
        });
      }
    });
    corpo.appendChild(galleria);

    if (puoInquadrare) {
      var scatta = el("button", "sp-primario", "Scattati una foto");
      scatta.type = "button";
      scatta.addEventListener("click", function () { apriFotocamera(corpo, config); });
      corpo.appendChild(scatta);

      var dalla = el("button", "sp-secondario", "Scegli dalla galleria");
      dalla.type = "button";
      dalla.addEventListener("click", function () { galleria.click(); });
      corpo.appendChild(dalla);
      scatta.focus();
    } else {
      var tasto = el("button", "sp-primario", c.tasto || "Carica la foto");
      tasto.type = "button";
      tasto.addEventListener("click", function () { galleria.click(); });
      corpo.appendChild(tasto);
      tasto.focus();
    }
  }

  /* LA FOTOCAMERA, DENTRO IL RIQUADRO.
     L'anteprima è SPECCHIATA, perché è così che ci si aspetta di vedersi e altrimenti
     inquadrarsi è goffo. Lo SCATTO invece si prende dritto: una foto specchiata ribalta
     scritte e loghi del capo, e il programma che compone l'immagine li rifarebbe al
     contrario. Due cose diverse per un motivo, non per una svista.

     E la fotocamera si spegne SEMPRE: appena si scatta, appena si chiude, appena qualcosa
     va storto. Una spia accesa su un sito di un negozio, dopo che la persona ha finito, è
     il modo più rapido di non essere più creduti su niente di quello che c'è scritto sopra. */
  function apriFotocamera(corpo, config) {
    corpo.innerHTML = "";
    corpo.appendChild(el("h2", "sp-tit", "Inquadrati"));

    var video = document.createElement("video");
    video.className = "sp-video";
    video.autoplay = true; video.muted = true; video.playsInline = true;
    video.setAttribute("playsinline", "");     // Safari vuole anche l'attributo, non solo la proprietà
    corpo.appendChild(video);

    var scatta = el("button", "sp-primario", "Scatta");
    scatta.type = "button";
    scatta.disabled = true;
    corpo.appendChild(scatta);

    var indietro = el("button", "sp-secondario", "Scegli dalla galleria");
    indietro.type = "button";
    indietro.addEventListener("click", function () { fermaFotocamera(); schermataConsenso(corpo, config); });
    corpo.appendChild(indietro);

    navigator.mediaDevices.getUserMedia({
      video: { facingMode: "user", width: { ideal: 1280 }, height: { ideal: 1280 } },
      audio: false,
    }).then(function (f) {
      flusso = f;
      video.srcObject = f;
      scatta.disabled = false;
      scatta.focus();
    }).catch(function () {
      /* Permesso negato, o nessuna fotocamera. Non è un guasto e non si dice come se lo
         fosse: si torna alla strada che funziona di sicuro, dicendo perché. */
      corpo.innerHTML = "";
      corpo.appendChild(el("h2", "sp-tit", "Nessuna fotocamera"));
      corpo.appendChild(el("p", "sp-sotto", "Il browser non me l'ha lasciata aprire. Puoi scegliere una foto che hai già."));
      var g = el("button", "sp-primario", "Scegli dalla galleria");
      g.type = "button";
      g.addEventListener("click", function () { schermataConsenso(corpo, config); });
      corpo.appendChild(g);
      g.focus();
    });

    scatta.addEventListener("click", function () {
      if (!video.videoWidth) return;
      var tela = document.createElement("canvas");
      tela.width = video.videoWidth;
      tela.height = video.videoHeight;
      tela.getContext("2d").drawImage(video, 0, 0);
      var scatto = tela.toDataURL("image/jpeg", 0.9);
      fermaFotocamera();
      stringi(scatto).then(function (d) { scegliTaglia(corpo, config, d || scatto); });
    });
  }

  /* 2. LA TAGLIA ABITUALE. Facoltativa, e detto: senza, la prova si fa lo stesso e non
        esce nessun consiglio. Chiederla come obbligatoria farebbe abbandonare. */
  function scegliTaglia(corpo, config, foto) {
    if (!config.consigliaTaglia) return genera(corpo, foto, "");
    corpo.innerHTML = "";
    corpo.appendChild(el("h2", "sp-tit", "Che taglia porti di solito?"));
    corpo.appendChild(el("p", "sp-sotto", "Così ti dico quale prendere di questo. Se preferisci, salta pure."));

    var riga = el("div", "sp-taglie");
    var scelta = "";
    ["XS", "S", "M", "L", "XL", "XXL"].forEach(function (t) {
      var b = el("button", "sp-taglia", t);
      b.type = "button";
      b.addEventListener("click", function () {
        scelta = t;
        riga.querySelectorAll(".sp-taglia").forEach(function (o) { o.classList.remove("on"); });
        b.classList.add("on");
        genera(corpo, foto, scelta);
      });
      riga.appendChild(b);
    });
    corpo.appendChild(riga);

    var salta = el("button", "sp-secondario", "Salta");
    salta.type = "button";
    salta.addEventListener("click", function () { genera(corpo, foto, ""); });
    corpo.appendChild(salta);
  }

  /* 3. LA PROVA. */
  function genera(corpo, foto, taglia) {
    corpo.innerHTML = "";
    var att = attesa(corpo);

    Promise.resolve(foto).then(function (dataUrl) {
      if (!dataUrl) { att.remove(); return errore(corpo, "Questa foto non riesco ad aprirla: scegline un'altra."); }
      return parla("prova", {
        prodotto: PRODOTTO,
        foto: dataUrl,
        consenso: true,
        tagliaAbituale: taglia,
        note: TITOLO,
      }).then(function (r) {
        att.remove();
        if (!r || !r.ok) return errore(corpo, (r && r.errore) || "Non ci sono riuscito. Riparti da capo fra un momento.");
        ultimaFoto = r.foto || null;
        risultato(corpo, r);
      });
    }).catch(function () {
      att.remove();
      errore(corpo, "Non ci sono riuscito: controlla la connessione e riparti.");
    });
  }

  function errore(corpo, testo) {
    corpo.innerHTML = "";
    corpo.appendChild(el("p", "sp-errore", testo));
    var b = el("button", "sp-secondario", "Chiudi");
    b.type = "button"; b.addEventListener("click", chiudi);
    corpo.appendChild(b);
  }

  /* 4. IL RISULTATO. L'avviso sta SOTTO l'immagine e non in fondo alla schermata: chi
        guarda la foto deve leggerlo senza cercarlo. */
  function risultato(corpo, r) {
    corpo.innerHTML = "";
    var img = new Image();
    img.className = "sp-esito";
    img.alt = "Il capo addosso a te";
    img.src = r.immagine;
    corpo.appendChild(img);

    corpo.appendChild(el("p", "sp-avviso", r.avviso || ""));

    if (r.taglia) {
      var t = el("div", "sp-consiglio" + (r.taglia.ripiego ? " ripiego" : ""));
      t.appendChild(el("strong", null, "Taglia " + r.taglia.taglia));
      t.appendChild(el("span", null, r.taglia.perche));
      corpo.appendChild(t);
    } else if (r.tagliaPerche) {
      corpo.appendChild(el("p", "sp-sotto", r.tagliaPerche));
    }

    var azioni = el("div", "sp-azioni");

    var carrello = el("button", "sp-primario", "Aggiungi al carrello");
    carrello.type = "button";
    carrello.addEventListener("click", function () {
      // Si dichiara a SIGNAL e si lascia fare al tema: il carrello è suo, e ogni tema ha
      // il suo modo. Aprire la scheda è l'unica azione che funziona su tutti.
      parla("evento", { prodotto: PRODOTTO, tipo: "carrello" }).catch(function () {});
      /* Il contrassegno PRIMA di lasciar fare al tema: se il modulo del tema ricarica la
         pagina, quello che parte dopo non parte. `keepalive` regge la ricarica, ma l'ordine
         giusto costa niente e non dipende da una promessa del browser. */
      contrassegnaCarrello(function () {
        chiudi();
        var form = document.querySelector('form[action*="/cart/add"]');
        if (form) { if (typeof form.requestSubmit === "function") form.requestSubmit(); else form.submit(); }
      });
    });
    azioni.appendChild(carrello);

    /* «CANCELLA LA MIA FOTO». Sta qui, accanto al risultato, e non in un menù: è la
       promessa fatta due schermate fa, e una promessa che si mantiene solo se si trova. */
    var via = el("button", "sp-secondario", "Cancella la foto");
    via.type = "button";
    via.addEventListener("click", function () {
      via.disabled = true;
      via.textContent = "Cancellata";
      parla("dimentica", { foto: ultimaFoto }).catch(function () {});
      ultimaFoto = null;
    });
    azioni.appendChild(via);
    corpo.appendChild(azioni);
  }

  /* ── L'AVVIO ─────────────────────────────────────────────────────────────
     Si chiede al server se la Prova è accesa su QUESTO capo. Solo allora compare il
     pulsante. Qualunque guasto qui dentro finisce in silenzio: il negozio resta com'era,
     che è il comportamento giusto per un pezzo che vive sul sito di un cliente. */
  var bottone = null;

  fetch(url("avvio") + "&tipo=" + encodeURIComponent(TIPO), { method: "GET" })
    .then(function (r) { return r.json(); })
    .then(function (config) {
      if (!config || !config.ok || !config.acceso || !config.gettone) return;
      gettone = config.gettone;
      riferimento = config.riferimento || null;
      bottone = el("button", "sp-invito");
      bottone.type = "button";
      bottone.setAttribute("aria-haspopup", "dialog");
      bottone.appendChild(gruccia());
      bottone.appendChild(el("span", "sp-invito-t", config.invito || "Camerino virtuale"));
      bottone.addEventListener("click", function () { apri(config); });
      posto.appendChild(bottone);
      // Dopo l'inserimento: prima non ha un padre, e la larghezza non si può misurare.
      vestiComeIlTema(bottone);
    })
    .catch(function () { /* il negozio resta com'era */ });
})();
